export enum ReportStatus {
  PENDING_REVIEW = "PENDING REVIEW",
  AWAITING_INPUT = "AWAITING INPUT",
  IN_CO_REVIEW = "IN CO REVIEW",
  CHANGES_REQUESTED = "CHANGES REQUESTED",
  CO_APPROVED = "CO APPROVED",
  RMS_COMMITTED = "RMS COMMITTED",
  SIGNED = "SIGNED",
  GENERATING = "GENERATING"
}
